export default __webpack_public_path__ + "static/media/p-3-mobile.5f984de6.png";